// Others
import axiosClient from './axiosClient';
import { urlApiMaterial } from '~/utils/constants/apis';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IMaterial,
  IMaterialDetail,
  IQueryParamMaterial,
  IQueryUpdateMaterial,
} from '~/utils/interface/material';

const materialApi = {
  getMaterial: (params: IQueryParamMaterial) => {
    const url = urlApiMaterial.getMaterialList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IMaterial[]>>>(url, { params });
  },

  getMaterialDetail: (materialId: string) => {
    const url = urlApiMaterial.getMaterialDetail(materialId);
    return axiosClient.get<IBaseResponse<IMaterialDetail>>(url);
  },

  createMaterial: (formData: FormData) => {
    const url = urlApiMaterial.createMaterial;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  deleteMaterial: (materialId: string) => {
    const url = urlApiMaterial.deleteMaterial(materialId);
    return axiosClient.delete<IBaseResponse>(url);
  },

  updateMaterial: ({ materialId, body }: IQueryUpdateMaterial) => {
    const url = urlApiMaterial.updateMaterial(materialId);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },
};

export default materialApi;
